import { Checkbox, type CheckboxProps } from '@chakra-ui/react'
import { SizeType } from '@/types'
import React from 'react'


interface Props extends CheckboxProps {
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Checkbox ref={ref} { ...props } />
  )
})


export {
  Component as Checkbox,
  type Props as CheckboxProps,
}